import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en/common.json';
import de from './locales/de/common.json';
import es from './locales/es/common.json';
import landingEn from './locales/en/landing.json';
import landingDe from './locales/de/landing.json';
import landingEs from './locales/es/landing.json';
import productsEn from './locales/en/products.json';
import productsDe from './locales/de/products.json';
import productsEs from './locales/es/products.json';

export const SUPPORTED_LOCALES = ['en', 'de', 'es'];

function initialLocale() {
  const url = new URL(window.location.href);
  const query = url.searchParams.get('locale');
  const stored = window.localStorage.getItem('leadCreatorLocale');
  const safeQuery = SUPPORTED_LOCALES.includes(query) ? query : null;
  const candidate = safeQuery || stored || 'en';

  // The handoff locale is an initial preference, not a permanent URL lock.
  // Consume it once so a later selector change persists after reload.
  if (query !== null) {
    url.searchParams.delete('locale');
    window.history.replaceState(
      window.history.state,
      '',
      `${url.pathname}${url.search}${url.hash}`,
    );
  }

  return SUPPORTED_LOCALES.includes(candidate) ? candidate : 'en';
}

i18n.use(initReactI18next).init({
  resources: {
    en: { common: en, landing: landingEn, products: productsEn },
    de: { common: de, landing: landingDe, products: productsDe },
    es: { common: es, landing: landingEs, products: productsEs },
  },
  lng: initialLocale(),
  fallbackLng: 'en',
  defaultNS: 'common',
  interpolation: { escapeValue: false },
  returnNull: false,
});

function persistLocale(locale) {
  const safe = SUPPORTED_LOCALES.includes(locale) ? locale : 'en';
  window.localStorage.setItem('leadCreatorLocale', safe);
  document.documentElement.lang = safe;
}

persistLocale(i18n.language);
i18n.on('languageChanged', persistLocale);

export default i18n;
